import SendCannedMessagesView from './SendCannedMessagesView'
export default SendCannedMessagesView
